import { useLocale } from '../i18n/LocaleContext';
import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const TermsPage = () => {
  const { t } = useLocale();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Section>
        <SectionTitle>{' '}{t('terms.001')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('terms.002')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.003')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('terms.004')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.005')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('terms.006')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.007')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('terms.008')}{' '}</p>
          <p>{' '}{t('terms.009')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.010')}{' '}</SectionTitle>
        <SectionContent>
          <ul>
            <li>{' '}{t('terms.011')}{' '}</li>
            <li>{' '}{t('terms.012')}{' '}</li>
            <li>{' '}{t('terms.013')}{' '}</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.014')}{' '}</SectionTitle>
        <SectionContent>
          <ul>
            <li>{' '}{t('terms.015')}{' '}</li>
            <li>{' '}{t('terms.016')}{' '}</li>
            <li>{' '}{t('terms.017')}{' '}</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.018')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('terms.019')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.020')}{' '}</SectionTitle>
        <SectionContent>
          <ul>
            <li>{' '}{t('terms.021')}{' '}</li>
            <li>{' '}{t('terms.022')}{' '}</li>
            <li>{' '}{t('terms.023')}{' '}</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.024')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('terms.025')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.026')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('terms.027')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.028')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('terms.029')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.030')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('terms.031')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.032')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('terms.033')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.034')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('terms.035')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.036')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('terms.037')}{' '}</p>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>{' '}{t('terms.038')}{' '}</SectionTitle>
        <SectionContent>
          <p>{' '}{t('terms.039')}{' '}<ContactEmail href="mailto:founders@noteician.com">founders@noteician.com</ContactEmail>
          </p>
        </SectionContent>
      </Section>

      <LastUpdated>{' '}{t('terms.040')}{' '}</LastUpdated>
    </motion.div>
  );
};

const Section = styled.div`
  margin-bottom: 30px;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: var(--primary-dark);
`;

const SectionContent = styled.div`
  color: var(--dark-gray);
  line-height: 1.6;

  p {
    margin-bottom: 15px;
  }

  ul {
    margin-bottom: 15px;
    padding-inline-start: 20px;

    li {
      margin-bottom: 8px;
    }
  }
`;

const ContactEmail = styled.a`
  color: var(--primary);
  font-weight: 500;
  text-decoration: none;
  margin-inline-start: 5px;

  &:hover {
    text-decoration: underline;
  }
`;

const LastUpdated = styled.p`
  font-style: italic;
  color: var(--secondary);
  text-align: center;
  margin-top: 50px;
  font-size: 0.9rem;
`;

export default TermsPage;
